import React, { ReactNode, useEffect } from "react";
import styles from "./BillPageLayout.module.scss";

interface BillPageLayoutLayoutProps {
	title: string;
	children: ReactNode;
}

const BillPageLayout: React.FC<BillPageLayoutLayoutProps> = ({ title, children }) => {
	
	return (
		<div className={styles.container}>
			{title && <div className={styles.titleContainer}>
				<h1 className={styles.title}>{title}</h1>
			</div>}
			<div className={styles.content}>{children}</div>
		</div>
	);
};

export default BillPageLayout;
